import { request } from "../request";
import { BatchTestClaimTypes } from "@/types";
import { BATCH_TEST_URLS } from "@/App/constants/urls";

/**
 * Retrieves a single batch test file.
 * @param payload: The ID of the batch test requested
 * @param authToken: Token for the request
 * @returns BatchTestClaimTypes.BatchTestClaim
 */
export async function getBatchTestAPI(authToken: string, payload: string): Promise<BatchTestClaimTypes.BatchTestClaim> {
  return await request<BatchTestClaimTypes.BatchTestClaim>(
    {
      url: BATCH_TEST_URLS.GET,
      method: "POST",
      data: { id: payload },
    },
    "adjudication",
    authToken,
  );
}
